module.exports = __webpack_public_path__ + "img/expert-3.c0a39050.png";